import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import EditIcon from '@mui/icons-material/Edit';
import Iconify from '../../ui-component/iconify';
import TableStyle from '../../ui-component/TableStyle';
import { useState } from 'react';
import { Stack, Button, Container, Typography, Box, Card } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import MenuItem from '@mui/material/MenuItem';
import * as React from 'react';
import { getApi } from 'views/services/api';
import { useEffect } from 'react';
import EditLaundary from './EditLaundary';
import AddLaundary from './AddLaundary';
import DeleteLaundary from './DeleteLaundary';
import moment from 'moment';

// ----------------------------------------------------------------------

const Laundary = () => {
  const [openAdd, setOpenAdd] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [laundaryId, setLaundaryId] = useState();
  const [laundaryData, setLaundaryData] = useState([]);
  const [propsData, setPropsData] = useState([]);
  const hotel = JSON.parse(localStorage.getItem('hotelData'));

  // function for  delete dialog/////////////////////////////////////
  const handleOpenDeleteLaundary = (id) => {
    setLaundaryId(id);
    setOpenDelete(true);
  };
  const handleCloseDeleteLaundary = () => setOpenDelete(false);

  // function for add dialog/////////////////////////////////////

  const handleOpenAddLaundary = () => setOpenAdd(true);
  const handleCloseLaundary = () => setOpenAdd(false);

  const handleOpenEditLaundary = (data) => {
    setPropsData(data);
    setOpenEdit(true);
  };
  const handleCloseEditLaundary = () => setOpenEdit(false);
  //-----------------------------------------------

  // function for fetching all the rooms data from the db

  const fetchLaundaryData = async () => {
    try {
      // const response = await getApi(`api/laundary/viewalllaundaries/${hotel._id}`);
      const response = await getApi(`api/laundary/viewalllaundaries/${hotel?.hotelId}`);
      setLaundaryData(response?.data?.laundaryData);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchLaundaryData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openAdd, openEdit, openDelete]);

  const columns = [
    {
      field: 'name',
      headerName: 'Laundary Name',
      flex: 1,
      cellClassName: ' name-column--cell--capitalize'
    },
    {
      field: 'quantity',
      headerName: 'Laundary Quantity',
      flex: 1
    },
    {
      field: 'amount',
      headerName: 'Amount / Item',
      flex: 1,
      renderCell: (params) => {
        return <Box>Rs {params?.value}</Box>;
      }
    },
    {
      field: 'totalAmount',
      headerName: 'Total Amount',
      flex: 1,
      renderCell: (params) => {
        return <Box>Rs {params?.row?.amount * params?.row?.quantity}</Box>;
      }
    },
    {
      field: 'createdDate',
      headerName: 'Date',
      flex: 1,
      renderCell: (params) => {
        return params?.value ? <Box>{moment(params?.value).format('YYYY-MM-DD')}</Box> : <Box sx={{ fontSize: '40px' }}>-</Box>;
      }
    },
    {
      field: 'status',
      headerName: 'Laundary Status',
      flex: 1,
      cellClassName: `name-column--cell--capitalize`,
      renderCell: (params) => {
        return params?.value === true ? (
          <Box sx={{ backgroundColor: '#42a142', color: 'white', padding: '10px', borderRadius: '10px' }}>Recieved</Box>
        ) : (
          <Button variant="contained" disabled>
            Pending
          </Button>
        );
      }
    },
    {
      field: 'action',
      headerName: 'Action',
      flex: 1,

      renderCell: (params) => {
        return (
          <>
            <MenuItem onClick={() => handleOpenEditLaundary(params?.row)} disableRipple>
              <EditIcon />
            </MenuItem>
            <MenuItem onClick={() => handleOpenDeleteLaundary(params.row._id)} sx={{ color: 'red' }} disableRipple>
              <DeleteIcon />
            </MenuItem>
          </>
        );
      }
    }
  ];

  return (
    <>
      <AddLaundary open={openAdd} handleClose={handleCloseLaundary} />
      <DeleteLaundary open={openDelete} handleClose={handleCloseDeleteLaundary} id={laundaryId} />
      <EditLaundary open={openEdit} handleClose={handleCloseEditLaundary} data={propsData} />

      <Container>
        <Stack direction="row" alignItems="center" mb={5} justifyContent={'space-between'}>
          <Typography variant="h4">Laundary-Management</Typography>
          <Stack direction="row" alignItems="center" justifyContent={'flex-end'} spacing={2}>
            <Button variant="contained" startIcon={<Iconify icon="eva:plus-fill" />} onClick={handleOpenAddLaundary}>
              Add Laundary
            </Button>
          </Stack>
        </Stack>
        <TableStyle>
          <Box width="100%">
            <Card style={{ height: '600px', paddingTop: '15px' }}>
              <Typography variant="h4" sx={{ margin: '2px 15px' }}>
                Laundaries ( {laundaryData?.length || 0} )
              </Typography>
              {laundaryData && (
                <DataGrid
                  rows={laundaryData}
                  // sx={{ overflowX: 'scroll' }}
                  columns={columns}
                  checkboxSelection
                  getRowId={(row) => row?._id}
                  slots={{ toolbar: GridToolbar }}
                  slotProps={{ toolbar: { showQuickFilter: true } }}
                />
              )}
            </Card>
          </Box>
        </TableStyle>
      </Container>
    </>
  );
};

export default Laundary;
